export enum LogMessageType {
    Warning = 'Warning',
    Info = 'Info',
    Error = 'Error',
    Exception = 'Exception'
}